<template>
	<div class="page-wrap">
		<categoryHeading :category="category" v-on:is-video-active="updateVideoActive(true)"></categoryHeading>
		<categoryTabs :categories="category.subCategories"></categoryTabs>
		<transition name="fade">
			<categoryVideo v-if="videoActive" :category="category" v-on:is-video-active="updateVideoActive(false)"></categoryVideo>
		</transition>
		<div class="category__imgs" v-if="category.categoryBg">
			<img class="category-img__bg" v-bind:src="category.categoryBg">
		</div>

		<div class="anim-leave"></div> 
	</div>
</template>

<script>
   import { CATEGORIES } from '@/js/categories.js';
   import categoryHeading from '@/components/CategoryHeading.vue';
   import categoryTabs from '@/components/CategoryTabs.vue';
   import categoryVideo from '@/components/CategoryVideo.vue';

	export default {
		name: 'category',
		components: {
			categoryHeading,
			categoryTabs,
			categoryVideo,
		},
		
		beforeRouteUpdate(to, from, next) {
			this.category = this.categories[to.params.id]
			next()
		},

		data: function() {
			return {
				category: null,
				categories: CATEGORIES,
				videoActive: false,
			}
		},

		methods: {
			updateVideoActive: function(isActiveVideo){
				this.videoActive = isActiveVideo
			},
		},
		
		created () {
			this.category = this.categories.find( cat => {
				return cat.urlSegment === this.$router.currentRoute.params.urlSegment
			})
		}
	}
</script>